var nfRadio = Backbone.Radio;
/** 
 * Inline data converted to globally available vars sent via wp_localize_script
 * We keep them globally accessible for backwards compatibility, 
 * we may want to remove them from global scope and communicate about that breaking change in the future
 **/
window.actionSettings = nfDashInlineVars.actionSettings;
window.preloadedFormData = nfDashInlineVars.preloadedFormData;
window.actionTypeData = nfDashInlineVars.actionTypeData;
window.formSettings = nfDashInlineVars.formSettings;
window.formSettingTypeData = nfDashInlineVars.formSettingTypeData;
window.mergeTags = nfDashInlineVars.mergeTags;
window.fieldTypeData = nfDashInlineVars.fieldTypeData;
window.fieldSettings = nfDashInlineVars.fieldSettings;
window.fieldTypeSections = nfDashInlineVars.fieldTypeSections;

document.addEventListener("DOMContentLoaded", function() {
	require( ['views/app/builder', 'controllers/loadControllers', 'views/loadViews'], function( BuilderView, LoadControllers, LoadViews ) {

		var NinjaForms = Marionette.Application.extend( {

			initialize: function( options ) {

				var that = this;
				Marionette.Renderer.render = function(template, data){
					var template = that.template( template );
					return template( data );
				};

				// Trigger an event before we load our controllers.
				nfRadio.channel( 'app' ).trigger( 'before:loadControllers', this );
				// Load our controllers.
				var loadControllers = new LoadControllers();
				// Trigger an event after we load our controllers.
				nfRadio.channel( 'app' ).trigger( 'after:loadControllers', this );

				// Trigger an event before we load un-instantiated views
				nfRadio.channel( 'app' ).trigger( 'before:loadViews', this );
				var loadViews = new LoadViews();
				// Trigger an event after we load un-instantiated views.
				nfRadio.channel( 'app' ).trigger( 'after:loadViews', this );

				nfRadio.channel( 'app' ).reply( 'get:template', this.template );
			},

			onStart: function() {
				var builderView = new BuilderView();
				// Trigger our after start event.
				nfRadio.channel( 'app' ).trigger( 'after:appStart', this );

				/*
				 * If we're on the new forms builder, open the add fields drawer.
				 */
				if ( 0 == nfAdmin.formID ) {
					nfRadio.channel( 'app' ).request( 'open:drawer', 'addField' );
				}

				/*
				 * Onboarding hooks
				 */
				if ('function' == typeof(NinjaOnboarding)) {
					window.nfOB = new NinjaOnboarding();
					nfOB.step(parseInt(nfAdmin.onboardingStep));
					this.listenTo(nfRadio.channel('app'), 'change:clean', function(isClean) {
						nfOB.cleanChanged(isClean);
					});
					this.listenTo(nfRadio.channel('drawer'), 'closed', function() {
						nfOB.drawerClosed()
					});
					this.listenTo(nfRadio.channel('drawer'), 'opened', function() {
						nfOB.drawerOpened()
					});
				}
			},

			template: function( template ) {
				return _.template( jQuery( template ).html(),  {
					evaluate:    /<#([\s\S]+?)#>/g,
					interpolate: /\{\{\{([\s\S]+?)\}\}\}/g,
					escape:      /\{\{([^\}]+?)\}\}(?!\})/g,
					variable:    'data'
				} );
			}
		} );
	
		var ninjaForms = new NinjaForms();
		ninjaForms.start();
	} );
} );
define("main", function(){});

